(function () {
  'use strict';

  angular.module('btUI', ['ngSanitize']);
})();
